<template>
  <div v-if="isShow()" id="sale-type">
    <div class="card">
      <div class="card-body">
        <div class="divide-y">
          <label class="row">
              <span class="col-4">
                <span class="title">Атрибут скидки</span>
              </span>
            <span class="col-8">
                <select class="form-select" v-model="fields.saleTypeId" :class="{ 'is-invalid': v$.saleTypeId.$error }" @change="onChangeSaleType">
                  <option v-for="item in saleTypeValues()" :key="item['value']" :value="item['value']" :disabled="isSaleTypeValuesDisabled(item['value'])">{{ item['name'] }}</option>
                </select>
                <div class="invalid-feedback" v-for="error in v$.saleTypeId.$errors" :key="error.$uid">
                  {{ error.$message }}
                </div>
              </span>
          </label>
          <template v-if="isShowSection(1)">
            <label class="row">
              <span class="col-6">
                <label class="form-label">Новая</label>
                <input v-model="fields.newPrice" type="number" class="form-control" placeholder="Новая цена" @change="changePriceNew" :class="{ 'is-invalid': v$.newPrice.$error }">
                <div class="invalid-feedback" v-for="error in v$.newPrice.$errors" :key="error.$uid">
                  {{ error.$message }}
                </div>
              </span>
              <span class="col-6">
                <label class="form-label">Старая</label>
                <input v-model="fields.oldPrice" type="number" class="form-control" placeholder="Старая цена" @change="changePriceOld" :class="{ 'is-invalid': v$.oldPrice.$error }">
                 <div class="invalid-feedback" v-for="error in v$.oldPrice.$errors" :key="error.$uid">
                  {{ error.$message }}
                </div>
              </span>
            </label>
          </template>
          <template v-if="isShowSection(2)">
            <div class="row g-2">
              <div class="col">
                <input max="100" min="1" v-model="fields.saleTypeValue" type="number" class="form-control" placeholder="Скидка в процентах" @change="changeSalePercent" :class="{'is-invalid': v$.saleTypeValue.$invalid && v$.saleTypeValue.$dirty}">
                <div class="invalid-feedback" v-for="error of v$.saleTypeValue.$silentErrors" :key="error.$uid">
                  {{ error.$message }}
                </div>
              </div>
              <div class="col-auto align-self-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-percentage"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M16 17a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M6 7a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M6 18l12 -12" /></svg>
              </div>
            </div>
          </template>
          <template v-if="isShowSection(3)">
            <div class="row g-2">
              <div class="col">
                <input v-model="fields.saleTypeValue" type="number" class="form-control" placeholder="Фиксированная скидка" @change="changeSaleFix" :class="{'is-invalid': v$.saleTypeValue.$invalid && v$.saleTypeValue.$dirty}">
                <div class="invalid-feedback" v-for="error of v$.saleTypeValue.$silentErrors" :key="error.$uid">
                  {{ error.$message }}
                </div>
              </div>
              <div class="col-auto align-self-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-currency-rubel"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M8 19v-14h6a3 3 0 0 1 0 6h-8" /><path d="M14 15h-8" /></svg>
              </div>
            </div>
          </template>
          <template v-if="isShowSection(4)">
            <div class="row g-2">
              <div class="col">
                <input v-model="fields.saleTypeValue" type="number" class="form-control" placeholder="Текущая цена" @change="changePriceNow" :class="{'is-invalid': v$.saleTypeValue.$invalid && v$.saleTypeValue.$dirty}">
                <div class="invalid-feedback" v-for="error of v$.saleTypeValue.$silentErrors" :key="error.$uid">
                  {{ error.$message }}
                </div>
              </div>
              <div class="col-auto align-self-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-currency-rubel"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M8 19v-14h6a3 3 0 0 1 0 6h-8" /><path d="M14 15h-8" /></svg>
              </div>
            </div>
          </template>
          <template v-if="isShowSection(6)">
            <label class="row">
              <span class="col-12">
                <input v-model="fields.saleTypeValue" type="text" class="form-control" placeholder="Кастомный ввод" @change="changeCustom" :class="{'is-invalid': v$.saleTypeValue.$invalid && v$.saleTypeValue.$dirty}">
                <div class="invalid-feedback" v-for="error of v$.saleTypeValue.$silentErrors" :key="error.$uid">
                  {{ error.$message }}
                </div>
              </span>
            </label>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, onMounted, reactive, ref, watch, computed} from "vue"
import Helper from "@/services/Helper";
import {requiredIf, maxLength, minValue, maxValue, integer, selectRequired} from "@/plugins/vuelidator"
import {useVuelidate} from "@vuelidate/core"

const noneSaleTypeId = 0;
const newOldPriceSaleTypeId = 1;
const salePercentSaleTypeId = 2;
const saleFixSaleTypeId = 3;
const priceNowSaleTypeId = 4;
const freeSaleTypeId = 5;
const customSaleTypeId = 6;
const giftSaleTypeId = 7;
const noValueSaleTypeId = 8;

export default defineComponent({
  name: "SaleType",
  components: {},
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, {emit}) {
    let show = ref(false)

    const fields = reactive(getFields())

    let $externalResults = reactive({})

    const rules = computed(() => {
      const isCustom = fields.saleTypeId === customSaleTypeId
      const isSalePercent = fields.saleTypeId === salePercentSaleTypeId

      const saleTypeValueValidator = {
        required: requiredIf(() =>
            [
              salePercentSaleTypeId,
              saleFixSaleTypeId,
              priceNowSaleTypeId,
              customSaleTypeId,
              giftSaleTypeId,
            ].includes(fields.saleTypeId)
        ),
      }

      if (isCustom) {
        if (fields.typeId === 7) {
          saleTypeValueValidator.maxLength = maxLength(10)
        } else {
          saleTypeValueValidator.maxLength = maxLength(20)
        }
      }

      if (isSalePercent) {
        saleTypeValueValidator.integer = integer
        saleTypeValueValidator.minValue = minValue(1)
        saleTypeValueValidator.maxValue = maxValue(100)
      }

      return {
        saleTypeId: { selectRequired },
        saleTypeValue: saleTypeValueValidator,
        newPrice: {
          required: requiredIf(() =>
              [
                newOldPriceSaleTypeId,
              ].includes(fields.saleTypeId)
          ),
        },
        oldPrice: {},
      }
    })

    const v$ = useVuelidate(rules, fields, {$externalResults})

    function validate(fn) {
      v$.value.$clearExternalResults()
      return v$.value.$validate().then((resp) => {
        if (resp === true) {
          fn()
        }
      })
    }

    function resetValidations() {
      v$.value.$reset()
    }

    onMounted(async () => {
      markUnshow()
      markShow()
    })

    watch(() => props.payload, (v) => {
      resetValidations()
      updateFields(v)
    }, {
      immediate: true,
    })

    watch(() => fields.saleTypeId, () => {
      clearForm({
        newPrice: null,
        oldPrice: null,
        saleTypeValue: null,
      })
      pushEvent()
    })

    watch(() => fields.typeId, () => {
      fields.saleTypeId = noValueSaleTypeId
    })

    function clearForm(onlyFields = {}) {
      let items

      if (Helper.isEmptyObject(onlyFields)) {
        items = getFields()
      } else {
        items = onlyFields
      }

      for (let key of Object.keys(items)) {
        fields[key] = items[key]
      }
    }

    function getFields() {
      return {
        saleTypeId: null,
        newPrice: null,
        oldPrice: null,
        saleTypeValue: null,
        typeId: null,
      }
    }

    function isShowSection(id) {
      return id === fields.saleTypeId
    }

    function updateFields(query) {
      let saleTypeId = !Helper.isEmpty(query.saleTypeId) ? query.saleTypeId : noneSaleTypeId
      let saleTypeValue = !Helper.isEmpty(query.saleTypeValue) ? query.saleTypeValue : ""

      fields.newPrice = query.newPrice
      fields.oldPrice = query.oldPrice
      fields.saleTypeId = saleTypeId
      fields.saleTypeValue = saleTypeValue
      fields.typeId = query.typeId
    }

    function markShow() {
      show.value = true
    }

    function markUnshow() {
      show.value = false
    }

    function isShow() {
      return show.value === true
    }

    function changePriceNew(e) {
      let newPrice = null;
      let oldPrice = null;

      if (!Helper.isEmpty(e.target.value)) {
        newPrice = parseFloat(e.target.value)
      }

      if (!Helper.isEmpty(fields.oldPrice)) {
        oldPrice = fields.oldPrice
      }

      validate(() => {
        pushEvent({
          newPrice: newPrice,
          oldPrice: oldPrice,
        })
      })
    }

    function changePriceOld(e) {
      let newPrice = null;
      let oldPrice = null;

      if (!Helper.isEmpty(fields.newPrice)) {
        newPrice = fields.newPrice
      }

      if (!Helper.isEmpty(e.target.value)) {
        oldPrice = parseFloat(e.target.value)
      }

      validate(() => {
        pushEvent({
          newPrice: newPrice,
          oldPrice: oldPrice,
        })
      })
    }

    function changeSalePercent(e) {
      let val = null;

      if (!Helper.isEmpty(e.target.value)) {
        val = parseFloat(e.target.value)
      }

      validate(() => {
        pushEvent({
          saleTypeValue: val,
        })
      })
    }

    function changeSaleFix(e) {
      let val = null;

      if (!Helper.isEmpty(e.target.value)) {
        val = parseFloat(e.target.value)
      }

      validate(() => {
        pushEvent({
          saleTypeValue: val,
        })
      })
    }

    function changePriceNow(e) {
      let val = null;

      if (!Helper.isEmpty(e.target.value)) {
        val = parseFloat(e.target.value)
      }

      validate(() => {
        pushEvent({
          saleTypeValue: val,
        })
      })
    }

    function changeCustom(e) {
      validate(() => {
        pushEvent({
          saleTypeValue: e.target.value,
        })
      })
    }

    function pushEvent(
        {
          newPrice = null,
          oldPrice = null,
          saleTypeValue = null,
        } = {}) {
      emit("onChange", {
        sale_type_id: fields.saleTypeId > 0 ? fields.saleTypeId : null,
        sale_type_value: saleTypeValue,
        new_price: newPrice,
        old_price: oldPrice,
      })
    }

    function isSaleTypeValuesDisabled(val) {
      return val === noValueSaleTypeId
    }

    function saleTypeValues() {
      if (Helper.inArray([fields.typeId], [6, 8, 9, 10, 12, 13, 14])) {
        return [
          {
            "value": noValueSaleTypeId,
            "name": "Без значения",
          },
          {
            "value": noneSaleTypeId,
            "name": "Не выбрано",
          },
          {
            "value": newOldPriceSaleTypeId,
            "name": "Новая/старая цена",
          },
          {
            "value": salePercentSaleTypeId,
            "name": "Скидка в процентах",
          },
          {
            "value": saleFixSaleTypeId,
            "name": "Фиксированная скидка",
          },
          {
            "value": priceNowSaleTypeId,
            "name": "Текущая цена",
          },
          {
            "value": freeSaleTypeId,
            "name": "Бесплатно",
          },
          {
            "value": customSaleTypeId,
            "name": "Кастомный ввод",
          },
          {
            "value": giftSaleTypeId,
            "name": "Подарок",
          },
        ]
      } else if (Helper.inArray([fields.typeId], [7])) {
        return [
          {
            "value": noValueSaleTypeId,
            "name": "Без значения",
          },
          {
            "value": noneSaleTypeId,
            "name": "Не выбрано",
          },
          {
            "value": salePercentSaleTypeId,
            "name": "Скидка в процентах",
          },
          {
            "value": saleFixSaleTypeId,
            "name": "Фиксированная скидка",
          },
          {
            "value": priceNowSaleTypeId,
            "name": "Текущая цена",
          },
          {
            "value": freeSaleTypeId,
            "name": "Бесплатно",
          },
          {
            "value": customSaleTypeId,
            "name": "Кастомный ввод",
          },
          {
            "value": giftSaleTypeId,
            "name": "Подарок",
          },
        ]
      }
    }

    function onChangeSaleType() {
      if (fields.saleTypeId === 0) {
        validate(() => {})
      } else {
        v$.value.saleTypeId.$reset()
      }
    }

    return {
      isShow,
      fields,
      changePriceNew,
      changePriceOld,
      saleTypeValues,
      isShowSection,
      changeSalePercent,
      changeSaleFix,
      changePriceNow,
      changeCustom,
      v$,
      isSaleTypeValuesDisabled,
      onChangeSaleType,
    }
  }
})
</script>
